const LEAD_ID = 86;

const URLS = {
  PROD: "https://z.ynet.co.il/mShort/generics/Leads/api/api/",
  QA: "https://qa-a.ynet.co.il/mShort/generics/Leads/api/api/",
  LOCAL: "https://localhost:44382/api/",
};
const Environment = () => {
  if (window.location.href.includes("localhost")) {
    return "local";
  } else if (window.location.href.includes("qa")) {
    return "qa";
  } else {
    return "production";
  }
};
const ApiLink = () => {
  if (Environment() === "local") {
    return URLS.LOCAL;
  } else if (Environment() === "qa") {
    return URLS.QA;
  } else {
    return URLS.PROD;
  }
};
export { Environment, ApiLink, LEAD_ID };
